// extracted by mini-css-extract-plugin
export default {"detail_popout":"popout_detail_popout__l6rpv","button":"popout_button__p74Ic"};